const Accountability = {
    platform: "linkedin",
    post_amount: 0,
    request_amount: 0,
    messages_amount: 0
}

export default Accountability;
